<template>
  <div class="order-list">
    <div style="display: flex;justify-content: flex-end;padding: 20px;" v-if="type === 'history'">
      <div style="margin-right: 10px;">Total Profit And Loss: <span style="color: #dc3545;">{{ postData.profit }}</span>
      </div>
      <div>Current Margin: <span style="color: #0d6efd;">{{ postData.margin }}</span></div>
    </div>
    <!-- 当 type 为 holding 时显示 Total Profit And Loss -->
    <div style="display: flex;justify-content: flex-end;padding: 20px;" v-if="type === 'holding'">
      <div style="margin-right: 10px;">Total Profit And Loss: <span style="color: #dc3545;">{{ totalProfit }}</span>
      </div>
      <div>Current Margin: <span style="color: #0d6efd;">{{ postData.margin }}</span></div>
    </div>
    <!-- 其他代码保持不变 -->
    <LoadingOverlay :show="loading" />
    <!-- Desktop View -->
    <div class="desktop-view">
      <el-table size="small" align="center" :data="data" style="width: 100%" v-if="type === 'holding'">
        <el-table-column prop="Transaction_pairs" label="Transaction pairs" />
        <el-table-column prop="Reservation_number" label="Reservation number" />
        <el-table-column prop="direction" label="direction">
          <template #default="scope">
            <span class="order-type" :class="scope.row.direction === 1 ? 'buy' : 'sell'">{{ scope.row.direction === 1 ?
              "Buy" : "Sell" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="Lots" label="Lots" />
        <el-table-column prop="Lower_unit_price" label="Lower unit price" />
        <el-table-column prop="Current_price" label="Current price" :formatter="formatPrice" />
        <el-table-column prop="Take_Profit" label="Take Profit" />
        <el-table-column prop="Set_Loss" label="Set Loss" />
        <el-table-column prop="Handling_fee" label="Handling fee" />
        <el-table-column prop="Margin" label="Margin" />
        <el-table-column prop="profit" label="profit" :formatter="formatProfit" />
        <el-table-column prop="Open_time" label="Open time" :formatter="formatterTime" />
        <el-table-column prop="Operation" label="Operation" width="200px">
          <template #default="scope">
            <button type="button" class="btn btn-outline-primary btn-sm" @click="handleTpSl(scope.row)">
              TP/SL
            </button>
            <button type="button" class="btn btn-outline-danger btn-sm" @click="handleClosePosition(scope.row)">
              Close position
            </button>
          </template>
        </el-table-column>
      </el-table>
      <el-table size="small" align="center" :data="data" style="width: 100%" v-else-if="type === 'pending'">
        <el-table-column prop="Transaction_pairs" label="Transaction pairs" />
        <el-table-column prop="Reservation_number" label="Reservation number" />
        <el-table-column prop="direction" label="direction">
          <template #default="scope">
            <span class="order-type" :class="scope.row.direction === 1 ? 'buy' : 'sell'">{{ scope.row.direction === 1 ?
              "Buy" : "Sell" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="Lots" label="Lots" />
        <el-table-column prop="Lower_unit_price" label="Lower unit price" />
        <el-table-column prop="Current_price" label="Current price" :formatter="formatPrice" />
        <el-table-column prop="Take_Profit" label="Take Profit" />
        <el-table-column prop="Set_Loss" label="Set Loss" />
        <el-table-column prop="Handling_fee" label="Handling fee" />
        <el-table-column prop="profit" label="profit" :formatter="formatProfit" />
        <el-table-column prop="Open_time" label="Open time" :formatter="formatterTime" />
        <el-table-column prop="Operation" label="Operation" width="200px">
          <template #default="scope">
            <button type="button" class="btn btn-outline-danger btn-sm" @click="handleCancelOrder(scope.row)">
              Cancle order
            </button>
          </template>
        </el-table-column>
      </el-table>
      <el-table size="small" align="center" :data="data" style="width: 100%" v-else-if="type === 'history'"
        @row-click="showMobileDetailCopy">
        <el-table-column prop="Transaction_pairs" label="Transaction pairs" />
        <el-table-column prop="Reservation_number" label="Reservation number" />
        <el-table-column prop="direction" label="direction">
          <template #default="scope">
            <span class="order-type" :class="scope.row.direction === 1 ? 'buy' : 'sell'">{{ scope.row.direction === 1 ?
              "Buy" : "Sell" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="Lots" label="Lots" />
        <el-table-column prop="Lower_unit_price" label="Lower unit price" />
        <el-table-column prop="Cheap_warehouse_price" label="Cheap warehouse price" />
        <el-table-column prop="Take_Profit" label="Take Profit" />
        <el-table-column prop="Set_Loss" label="Set Loss" />
        <el-table-column prop="Handling_fee" label="Handling fee" />
        <el-table-column prop="Margin" label="Margin" />
        <el-table-column prop="profit" label="profit" :formatter="formatProfit" />
        <el-table-column prop="Open_time" label="Open time" :formatter="formatterTime" />
        <el-table-column prop="Closing_time" label="Close time" :formatter="formatterTime" />
      </el-table>
    </div>

    <!-- Mobile View -->
    <div class="mobile-view">
      <div class="mobile-list">
        <div v-for="item in data" :key="item.id" class="mobile-list-item" @click="showMobileDetail(item)">
          <div class="item-header">
            <span class="pairs">{{ item.Transaction_pairs }}</span>
            <span class="order-type" :class="item.direction === 1 ? 'buy' : 'sell'">
              {{ item.direction === 1 ? "Buy" : "Sell" }}
            </span>
          </div>
          <div class="item-body">
            <div class="info-row">
              <span class="label">Lots:</span>
              <span class="value">{{ item.Lots }}</span>
            </div>
            <div class="info-row" v-if="type !== 'history'">
              <span class="label">Cuurrent price:</span>
              <span class="value">{{ formatPrice(item) }}</span>
            </div>
            <div class="info-row">
              <span class="label">Profit:</span>
              <span class="value" :class="formatProfit(item) >= 0
                ? 'profit-positive'
                : 'profit-negative'
                ">
                {{ formatProfit(item) }}
              </span>
            </div>
            <div class="info-row">
              <span class="label">Open time:</span>
              <span class="value">{{
                formatterTime(item, { property: "Open_time" })
              }}</span>
            </div>
          </div>
          <template v-if="type == 'holding'">
            <div class="rowBtn">
              <button type="button" class="btn btn-outline-primary btn-sm" @click="handleTpSl(item)">
                TP/SL
              </button>
              <button type="button" class="btn btn-outline-danger btn-sm" @click="handleClosePosition(item)">
                Close position
              </button>
            </div>
          </template>
          <div class="rowBtn" v-if="type == 'pending'">
            <button type="button" class="btn btn-outline-danger btn-sm" @click="handleCancelOrder(item)">
              Cancle order
            </button>
          </div>
        </div>
      </div>
    </div>

    <Pagination v-if="page.total > page.pageSize" :total="page.total" :pageSize="page.pageSize"
      v-model:currentPage="page.currentPage" />

    <!-- Bottom Sheet Detail -->
    <div class="bottom-sheet" :class="{ active: mobileDetailVisible }">
      <div class="bottom-sheet-mask" @click="handleCloseMask"></div>
      <div class="bottom-sheet-wrapper" :class="{ 'pc': !isMobileDevice }">
        <div class="bottom-sheet-header">
          <div class="order-title">
            <div class="symbol">
              <span class="symbol-text">{{
                selectedItem.Transaction_pairs
              }}</span>
              <span class="d-order-type d-buy" :class="selectedItem.direction === 1 ? 'd-buy' : 'd-sell'">{{
                selectedItem.direction === 1 ? "buy" : "sell" }} {{ selectedItem.lots }}</span>
              <span class="order-id">{{
                selectedItem.Reservation_number
              }}</span>
            </div>
            <div class="sub-title">{{ selectedItem.code_text }}</div>
          </div>
        </div>
        <div class="bottom-sheet-content">
          <div class="price-section">
            <div class="price-change">
              <div class="price-row">
                <span>{{ selectedItem.start_money }}</span>
                <span class="arrow">→</span>
                <span>{{ selectedItem.end_money }}</span>
              </div>
              <div class="delta-row">
                <span class="delta up">Δ = {{ selectedItem.triangle }}
                  {{ parseInt(selectedItem.triangle) > 0 ? "↑" : "↓" }} {{ selectedItem.triangle_percent }}</span>
              </div>
            </div>
            <div class="total-amount">{{ selectedItem.profit }}</div>
          </div>

          <div class="time-section">
            <div>
              {{ selectedItem.Open_time }} →{{ selectedItem.Closing_time }}
            </div>
          </div>

          <div class="detail-group">
            <div class="detail-row">
              <div class="detail-item">
                <span class="label">S/L:</span>
                <span class="value" v-if="mobileDetailVisible">-</span>
                <span class="value" v-else>{{ selectedItem.Set_Loss }}</span>
              </div>
              <div class="detail-item">
                <span class="label">Swap:</span>
                <span class="value">{{ selectedItem.Swap }}</span>
              </div>
            </div>
            <div class="detail-row">
              <div class="detail-item">
                <span class="label">T/P:</span>
                <span class="value" v-if="mobileDetailVisible">-</span>
                <span class="value" v-else>{{ selectedItem.Take_Profit }}</span>
              </div>
              <div class="detail-item">
                <span class="label">Charges:</span>
                <span class="value">{{ selectedItem.Charges }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-sheet-footer">
          <div class="action-buttons">
            <button class="action-btn" @click="selectedBI('chart')">
              Chart
            </button>
            <button class="action-btn" @click="selectedBI('trade')">
              Trade
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Original TP/SL Dialog -->
    <el-dialog v-model="TPSLVisible" title="TP/SL" width="300">
      <el-form :model="tpslForm" label-width="100">
        <el-form-item label="Take Profit">
          <el-input-number style="width: 100%" v-model="tpslForm.tp" :min="0" />
        </el-form-item>
        <el-form-item label="Set Loss">
          <el-input-number style="width: 100%" v-model="tpslForm.sl" :min="0" />
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <!-- <el-button @click="TPSLVisible = false">Cancel</el-button> -->
          <el-button type="primary" :loading="setTPSLLoading" @click="setTPSL">
            Set TP/SL
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>

</template>

<script>
import dayjs from "dayjs";
import Pagination from "@/components/Pagination.vue";
import {
  getUserContractOrderList,
  setContractOrder,
  cancelAutoContractOrder,
  endContractOrder,
} from "@/apis/wallet";
import LoadingOverlay from "../LoadingOverlay.vue";
import { message } from "@/utils/message";
import { isMobileDevice } from "@/utils/index";
export default {
  name: "PositionHolding",
  props: {
    type: {
      type: String,
      default: "holding", // holding, pending, history
      validator: (value) => ["holding", "pending", "history"].includes(value),
    },
    biList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showChat: true, // true 显示 / false 隐藏
      loading: false,
      data: [],
      page: {
        total: 0,
        pageSize: 50,
        currentPage: 1,
      },
      types: {
        holding: "1",
        pending: "2",
        history: "10",
      },
      timer: null,
      TPSLVisible: false,
      tpslForm: {
        tp: "",
        sl: "",
      },
      setTPSLLoading: false,
      mobileDetailVisible: false,
      selectedItem: {},
      postData: {},
      isMobileDevice: isMobileDevice()
    };
  },
  computed: {
    allBiPrice() {
      if (this.biList.length === 0) {
        return {};
      }
      let obj = {};
      this.biList.forEach((bi) => {
        obj[bi.bi_id] = bi.price;
      });
      return obj;
    },
    // 新增计算属性：实时统计 holding 订单的总盈亏
    totalProfit() {
      if (this.type !== 'holding') {
        return 0;
      }
      return this.data.reduce((total, order) => {
        return total + this.calculateForexProfit(
          order.Lower_unit_price,
          this.formatPrice(order),
          order.decimal_points,
          order.amount_per_point,
          order.leverage,
          order.direction,
          order.profit,
          order.Lots
        );
      }, 0);
    }
  },
  components: {
    Pagination,
    LoadingOverlay,
    //LiveChatWidget
  },
  mounted() {
    console.log("mounted" + this.showChat);

    this.$bus.on("order-submitted", this.handleOrderSubmitted);
    this.getOrderList();
    if (this.type === "holding" || this.type === "pending") {
      this.startPolling();
    }
  },
  methods: {
    // 关闭遮罩层时打开聊天窗口
    handleCloseMask() {
      this.mobileDetailVisible = false; // 关闭弹窗
      this.$store.commit("setShowLiveChat", true);// 显示聊天窗口

    },
    showMobileDetailCopy(row) {
      console.log(row)
      this.showMobileDetail(row)
    },
    calculateForexProfit(
      buyPrice,
      currentPrice,
      decimalPoints,
      amountPerPoint,
      leverage,
      direction,
      profit,
      lots
    ) {
      if (this.type == 'history') {
        return profit;
      }

      const standardLotUnits = 100000; // 标准手的单位（1手=100,000）

      // 计算价格差
      let priceDifference;
      if (Number(direction) === 1) {
        // 做多：currentPrice - buyPrice
        priceDifference = currentPrice - buyPrice;
      } else if (Number(direction) === 2) {
        // 做空：buyPrice - currentPrice
        priceDifference = buyPrice - currentPrice;
      } else {
        throw new Error("Invalid direction: must be 1 (buy) or 2 (sell).");
      }

      // 计算最小单位
      const minUnit = Math.pow(10, -decimalPoints);

      // 计算价格点差
      const priceSpread = priceDifference / minUnit;

      // 计算基础利润
      const baseProfit = parseFloat((priceSpread * amountPerPoint * lots).toFixed(2));


      return baseProfit;
    },
    formatProfit(row) {
      return this.calculateForexProfit(
        row.Lower_unit_price,
        this.formatPrice(row),
        row.decimal_points,
        row.amount_per_point,
        row.leverage,
        row.direction,
        row.profit,
        row.Lots
      );
    },
    formatPrice(row) {
      return this.allBiPrice[row.bi_id] || 0;
    },
    formatterTime(row, column) {
      if (!row[column.property]) {
        return "";
      }
      return dayjs(row[column.property]).format("YYYY-MM-DD HH:mm:ss");
    },
    formatValue(value, formatter) {
      return formatter ? formatter(value) : value;
    },
    startPolling() {
      //return;
      this.stopPolling();
      this.poll();
    },
    stopPolling() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
    poll() {
      this.getOrderList(false).finally(() => {
        if (
          (this.type === "holding" || this.type === "pending") &&
          this.data.length > 0
        ) {
          this.timer = setTimeout(() => {
            this.poll();
          }, 5000);
        }
      });
    },
    handleOrderSubmitted() {
      this.getOrderList();
    },
    async getOrderList(showLoading = true) {
      try {
        if (showLoading) {
          this.loading = true;
        }
        const res = await getUserContractOrderList({
          status: this.types[this.type],
          page: this.page.currentPage,
          rows: this.page.pageSize,
        });
        if (res.code === 0) {
          this.data = res.data;
          this.page.total = res.count;
          this.postData = res;
          console.log("this.timer:" + this.timer);

          console.log("!this.timer:" + !this.timer);
          if (
            (this.type === "holding" || this.type === "pending") &&
            this.data.length > 0 &&
            !this.timer
          ) {
            this.startPolling();
          }
          if (this.data.length === 0) {
            this.stopPolling();
          }
        }
      } catch (error) {
        console.error("Failed to fetch order list:", error);
      } finally {
        if (showLoading) {
          this.loading = false;
        }
      }
    },
    handleTpSl(row) {
      console.log(row);
      this.selectedRow = JSON.parse(JSON.stringify(row));
      this.tpslForm.tp = row.Take_Profit;
      this.tpslForm.sl = row.Set_Loss;
      this.TPSLVisible = true;
    },
    handleClosePosition(row) {
      console.log(row);
      this.loading = true;
      endContractOrder({ id: row.id })
        .then(() => {
          message.success("Close position successfully");
          this.getOrderList();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCancelOrder(row) {
      console.log(row);
      this.loading = true;
      cancelAutoContractOrder({ id: row.id })
        .then(() => {
          message.success("Cancel order successfully");
          this.getOrderList();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async setTPSL() {
      console.log(this.selectedRow);
      this.setTPSLLoading = true;
      const res = await setContractOrder({
        id: this.selectedRow.id,
        max_lose_money: this.tpslForm.sl,
        max_win_money: this.tpslForm.tp,
      }).catch(() => {
        console.log(1);
      });

      this.setTPSLLoading = false;
      if (res?.code == 0) {
        message.success("Set TP/SL successfully");
        this.TPSLVisible = false;
        this.stopPolling();
        this.getOrderList().finally(() => {
          this.startPolling();
        });
      }
    },
    showMobileDetail(item) {
      if (this.type !== "history") {
        return;
      }
      this.selectedItem = item;
      this.mobileDetailVisible = true;
      //this.updateShowChat(false); // 关闭聊天窗口
      this.$store.commit("setShowLiveChat", false);// 显示聊天窗口

    },
    selectedBI(type) {
      this.mobileDetailVisible = false;

      this.$emit("chooseBiById", this.selectedItem.bi_id, type);
    },
  },
  beforeUnmount() {
    this.$bus.off("order-submitted", this.handleOrderSubmitted);
    this.stopPolling();
  },
  watch: {
    "page.currentPage"() {
      this.stopPolling();
      this.getOrderList().finally(() => {
        this.startPolling();
      });
    },
    type() {
      this.page.currentPage = 1;
      this.stopPolling();
      this.getOrderList().finally(() => {
        this.startPolling();
      });
    },
  },
};
</script>
<style scoped lang="scss">
.order-list {
  position: relative;
  min-height: 3%;
}

// Desktop styles
.desktop-view {
  display: block;

  @media (max-width: 768px) {
    display: none;
  }
}

// Mobile styles
.mobile-view {
  display: none;

  @media (max-width: 768px) {
    display: block;
  }
}

.mobile-list {
  .mobile-list-item {
    background: #fff;
    border-radius: 12px;
    margin: 10px;
    padding: 15px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

    .item-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;

      .pairs {
        font-weight: 600;
        font-size: 16px;
      }
    }

    .item-body {
      .info-row {
        display: flex;
        justify-content: space-between;
        margin: 5px 0;

        .label {
          color: #666;
        }

        .value {
          font-weight: 500;
        }
      }
    }
  }
}

.order-type {
  color: #fff;
  padding: 6px 12px;
  border-radius: 6px;

  &.buy {
    background-color: #0d6efd;
  }

  &.sell {
    background-color: #dc3545;
  }
}

.profit-positive {
  color: #0d6efd;
}

.profit-negative {
  color: #dc3545;
}

// Bottom Sheet styles
.bottom-sheet {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 2000;
  visibility: hidden;

  &.active {
    visibility: visible;

    .bottom-sheet-mask {
      opacity: 1;
    }

    .bottom-sheet-wrapper {
      transform: translateY(0);
    }
  }
}

.bottom-sheet-mask {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.bottom-sheet-wrapper {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 16px 16px 0 0;
  transform: translateY(100%);
  transition: transform 0.3s cubic-bezier(0.36, 0.66, 0.04, 1);
  max-height: 85vh;
  overflow-y: auto;
  padding: 10px;
  /* iOS Momentum Scroll */
  -webkit-overflow-scrolling: touch;

  &.pc {
    margin: auto;
    width: 600px;
  }
}

.bottom-sheet-header {
  border-radius: 10px 10px 0 0;
  padding: 10px 5px;
  // padding-bottom: 16px;

  background: #f1f1f1;

  .order-title {
    .symbol {
      display: flex;
      align-items: center;
      gap: 4px;
      margin-bottom: 2px;

      .symbol-text {
        font-size: 18px;
        font-weight: 600;
        letter-spacing: -0.3px;
        color: #070506;
      }

      // .dot {
      //   color: #999;
      //   margin: 0 2px;
      // }

      .d-order-type {
        font-size: 18px;
        font-weight: 600;
        // padding: 1px 6px;
        // border-radius: 4px;
        // text-transform: lowercase;
        // line-height: 1.4;

        // &.buy {
        // background: #0d6efd;
        // color: white;
        // }
        &.d-buy {
          color: #0d6efd;
        }

        &.d-sell {
          color: #dc3545;
        }
      }

      .order-id {
        color: #434343;
        font-size: 14px;
        font-weight: normal;
        margin-left: auto;
      }
    }

    .sub-title {
      color: #8a8a8a;
      font-size: 14px;
      font-weight: normal;
    }
  }
}

.bottom-sheet-content {
  background: #f8f8f8;
  border-radius: 0 0 10px 10px;
  padding: 10px 5px;

  .price-section {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 12px;

    .price-change {
      color: #444;

      .price-row {
        font-size: 18px;
        font-weight: 500;
        margin-bottom: 2px;
        display: flex;
        align-items: center;
        gap: 6px;
        letter-spacing: -0.3px;

        .arrow {
          // color: #999;
          font-weight: normal;
          margin: 0 2px;
        }
      }

      .delta-row {
        .delta {
          font-size: 13px;
          letter-spacing: -0.2px;

          &.up {
            // color: #0d6efd;
            color: #187093;
          }
        }
      }
    }

    .total-amount {
      font-size: 14px;
      margin-top: 4px;
      font-weight: 500;
      // color: #0d6efd;
      color: #0273b7;
      letter-spacing: -0.3px;
    }
  }

  .time-section {
    margin-bottom: 16px;
    color: #4b4b4d;
    font-size: 13px;
    letter-spacing: -0.2px;
  }

  .detail-group {
    .detail-row {
      display: flex;
      justify-content: space-between;
      margin-bottom: 12px;

      &:last-child {
        margin-bottom: 0;
      }

      .detail-item {
        width: 42%;
        display: flex;

        &:nth-child(2) {
          width: 50%;
        }

        .label {
          color: #8c8c8c;
          font-size: 13px;
          margin-right: 4px;
        }

        .value {
          font-size: 13px;
          color: #565656;
          margin-left: auto;
        }
      }
    }
  }
}

.bottom-sheet-footer {
  background: #f8f8f8;
  margin-top: 8px;
  border-radius: 10px;

  .action-buttons {
    display: flex;
    flex-wrap: wrap;

    .action-btn {
      width: 100%;
      padding: 16px 0;
      border-radius: 10px;
      border: none;
      font-size: 15px;
      font-weight: 500;
      color: #0273b7;
      letter-spacing: -0.3px;
      background: transparent;

      &:active {
        background: #e9ecef;
      }
    }
  }
}

// Remove old modal styles
.ios-style-modal {
  display: none;
}

.modal-header {
  display: none;
}

.ios-detail-content {
  display: none;
}

::v-deep .el-table {
  background: transparent;

  th,
  td {
    text-align: center;
  }
}

.btn+.btn {
  margin-left: 10px;
}

.dark {
  .mobile-list .mobile-list-item {
    background: #2a2e39;
  }

  .mobile-list .mobile-list-item .item-body .info-row .label {
    color: #929aa5;
  }
}

.rowBtn {
  display: flex;
  justify-content: flex-end;
}
</style>
<!-- <style scoped>
.table th,
.table td {
  padding: 1rem;
  vertical-align: middle;
  white-space: nowrap;
}

.table thead th {
  border-bottom: 2px solid #2c3034;
  font-weight: 500;
}

.table tbody td {
  border-bottom: 1px solid #2c3034;
}

/* 暗色主题 */
.dark .table thead th {
  border-bottom-color: #2c3034;
}

.dark .table tbody td {
  border-bottom-color: #2c3034;
}

.table tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.03);
}

.dark .table tbody tr:hover {
  background-color: rgba(255, 255, 255, 0.03);
}
</style> -->
